/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CalendarDto } from '@gh/supplier-shared-data';
import { clone } from 'lodash';

export type CalendarModel = CalendarDto;

export const CALENDAR_DAYS: number = 42;
export const getDatesRange = (startDate: Date, endDate: Date): Date[] => {
  const dates = [];
  let currentDate = startDate;

  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
  }

  return dates;
};

export const getCalendar = (date: Date): Date[] => {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const startDate = new Date(firstDayOfMonth.setDate(firstDayOfMonth.getDate() - firstDayOfMonth.getDay()));
  const endDate = new Date(clone(startDate).setDate(startDate.getDate() + CALENDAR_DAYS - 1));

  return getDatesRange(startDate, endDate);
};
